import { render } from "./VerifyTransactionModal.vue?vue&type=template&id=245deaa6"
import script from "./VerifyTransactionModal.vue?vue&type=script&lang=js"
export * from "./VerifyTransactionModal.vue?vue&type=script&lang=js"

import "./VerifyTransactionModal.vue?vue&type=style&index=0&id=245deaa6&lang=css"
script.render = render

export default script